<template>
  <div>
      <Message :time="time" :message="message" :userName="userName"  messageHeader="Broadcast">
        <IconBase
            slot="icon"
            :height="24"
            :width="24"
            :view-box="`0 0 32 32`"
            :fill="'#50C6DF'"
        >
            <IconBrodcastGreen />
        </IconBase>
    </Message>
  </div>
</template>
<script>
import Message from './Message';
import IconBase from '../IconBase'
import IconBrodcastGreen from '../icons/IconBrodcastGreen'
export default {
    props: ['time', 'message', 'userName'],
    components: {
        Message,
        IconBase,
        IconBrodcastGreen
    }
}
</script>

<style>

</style>